import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import axios from 'axios';
import axiosInstance from '../../api/axiosConfig';
import './FormStyles.css';
import receptionBg from '../../assets/images/backgrounds/reception-bg.png';

const DeliveryForm = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { user } = useAuth();
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);

    const isPublic = location.pathname.startsWith('/visitor/form');

    const [formData, setFormData] = useState({
        visitorName: '',
        courierCompany: '',
        trackingNumber: '',
        contactNumber: '',
        recipientName: '',
        recipientDepartment: '',
        packageType: '',
        packageDescription: '',
        notes: ''
    });

    const API_URL = process.env.REACT_APP_API_URL || '';

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            if (isPublic) {
                await axios.post(
                    `${API_URL}/api/public/visitor-forms`,
                    {
                        formType: 'delivery',
                        formData,
                        notes: formData.notes
                    }
                );
            } else {
                await axiosInstance.post(
                    '/api/forms',
                    {
                        formType: 'delivery',
                        formData,
                        notes: formData.notes
                    }
                );
            }

            setSuccess(true);
            setTimeout(() => {
                navigate(isPublic ? '/visitor' : '/purpose-selection');
            }, 2000);
        } catch (error) {
            alert('Error submitting form: ' + (error.response?.data?.message || error.message));
        } finally {
            setLoading(false);
        }
    };

    const handleBack = () => {
        navigate(isPublic ? '/visitor' : '/purpose-selection');
    };

    return (
        <div className="form-container" style={{ backgroundImage: `url(${receptionBg})` }}>
            <div className="form-wrapper card fade-in">
                <div className="form-header">
                    <img src="/logo.png" alt="Logo" className="app-logo" />
                    <div className="form-header-text">
                        <h2>Delivery Registration</h2>
                        <p>Package and courier information</p>
                    </div>
                    <div className="form-header-actions">
                        {!isPublic && user && (
                            <div className="form-user-info">
                                <strong>{user?.fullName || user?.username}</strong>
                            </div>
                        )}
                        <button
                            type="button"
                            className="btn-back-form"
                            onClick={handleBack}
                        >
                            ← Back
                        </button>
                    </div>
                </div>

                {success && (
                    <div className="alert alert-success">
                        ✅ Delivery registered successfully! Redirecting...
                    </div>
                )}

                <form onSubmit={handleSubmit} className="visitor-form">
                    <div className="form-row">
                        <div className="form-group">
                            <label htmlFor="courierName" className="form-label">Courier Name *</label>
                            <input
                                type="text"
                                id="courierName"
                                name="courierName"
                                className="form-input"
                                value={formData.courierName}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="courierCompany" className="form-label">Courier Company *</label>
                            <input
                                type="text"
                                id="courierCompany"
                                name="courierCompany"
                                className="form-input"
                                value={formData.courierCompany}
                                onChange={handleChange}
                                required
                            />
                        </div>
                    </div>

                    <div className="form-row">
                        <div className="form-group">
                            <label htmlFor="trackingNumber" className="form-label">Tracking Number</label>
                            <input
                                type="text"
                                id="trackingNumber"
                                name="trackingNumber"
                                className="form-input"
                                value={formData.trackingNumber}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="packageType" className="form-label">Package Type *</label>
                            <select
                                id="packageType"
                                name="packageType"
                                className="form-select"
                                value={formData.packageType}
                                onChange={handleChange}
                                required
                            >
                                <option value="">Select type...</option>
                                <option value="document">Document</option>
                                <option value="parcel">Parcel</option>
                                <option value="equipment">Equipment</option>
                                <option value="other">Other</option>
                            </select>
                        </div>
                    </div>

                    <div className="form-row">
                        <div className="form-group">
                            <label htmlFor="recipientName" className="form-label">Recipient Name *</label>
                            <input
                                type="text"
                                id="recipientName"
                                name="recipientName"
                                className="form-input"
                                value={formData.recipientName}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="recipientDepartment" className="form-label">Department</label>
                            <input
                                type="text"
                                id="recipientDepartment"
                                name="recipientDepartment"
                                className="form-input"
                                value={formData.recipientDepartment}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    <div className="form-group">
                        <label htmlFor="packageDescription" className="form-label">Package Description</label>
                        <textarea
                            id="packageDescription"
                            name="packageDescription"
                            className="form-textarea"
                            value={formData.packageDescription}
                            onChange={handleChange}
                            rows="2"
                        ></textarea>
                    </div>

                    <div className="form-group">
                        <label htmlFor="notes" className="form-label">Additional Notes</label>
                        <textarea
                            id="notes"
                            name="notes"
                            className="form-textarea"
                            value={formData.notes}
                            onChange={handleChange}
                            rows="2"
                        ></textarea>
                    </div>

                    <div className="form-actions">
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={handleBack}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="btn btn-primary"
                            disabled={loading}
                        >
                            {loading ? 'Submitting...' : 'Register Delivery'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default DeliveryForm;
